module.exports = __webpack_public_path__ + "fonts/ttnorms-regular-webfont.3aa68a78.woff2";